import { Schema } from "effect";

// CON-3203: the models an Expert may pick for studio's generative work — chat edits, exercise
// authoring (the expander) and curriculum generation. A closed set, because every consumer forwards
// the id verbatim to an API or CLI that only rejects an unknown model late (a 400 on the first
// session, or minutes into a cluster run).
//
// Full model ids, not aliases: the pipelines' `opus`/`sonnet` aliases resolve to older generations
// (`l2_unit_plan`'s MODEL_ALIASES maps `opus` → `claude-opus-5`), so an alias would not deliver the
// model the Expert picked.
export const STUDIO_MODELS = ["claude-opus-5-5", "claude-fable-5-1", "claude-sonnet-5-5"] as const;
export const StudioModel = Schema.Literal(...STUDIO_MODELS);
export type StudioModel = typeof StudioModel.Type;

// Reasoning effort, the levels every studio model accepts. Absent = the model's own default
// (`medium` on Opus 5.5, `high` on Fable 5.1 and Sonnet 5.5).
export const MODEL_EFFORTS = ["low", "medium", "high", "xhigh", "max"] as const;
export const ModelEffort = Schema.Literal(...MODEL_EFFORTS);
export type ModelEffort = typeof ModelEffort.Type;

export const STUDIO_MODEL_LABELS: Readonly<Record<StudioModel, string>> = {
  "claude-opus-5-5": "Opus 5.5",
  "claude-fable-5-1": "Fable 5.1",
  "claude-sonnet-5-5": "Sonnet 5.5",
};

// An Expert's pick, as every generative request carries it. Both halves optional and independent:
// no model → the surface's configured default model; no effort → that model's default effort.
export const ModelChoice = Schema.Struct({
  model: Schema.optionalWith(StudioModel, { exact: true }),
  effort: Schema.optionalWith(ModelEffort, { exact: true }),
});
export type ModelChoice = typeof ModelChoice.Type;
